/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable mdx/no-unused-expressions */
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { isEmpty } from 'lodash'

import ParentHeader from '../components/layout/Header/ParentHeader'
import LeftNavigation from '../components/layout/LeftNavigation'
import RightNavigation from '../components/layout/RightNavigation'
import Footer from '../components/layout/Footer/Footer'
import IsAPIDeprecated from '../components/layout/SwaggerAPI/IsAPIDeprecated'
import { getRequest } from '../utils/request'
import { useApplicationContext } from '../provider'
import { withScriptLoader } from '../components/hoc'
import { useWindowSize } from '../hooks/useWindowSize/useWindowSize'

const Layout = ({
  rightNav,
  leftNav,
  children,
  data_type,
  layout,
  leftNavBar,
  location,
  onMount,
  isDeprecated,
  apiLatestVersion,
  apiLatestVersionPath,
  title = 'PayPal Developer',
  description,
  keywords,
  contentType,
  productStatus,
  apiVersion,
  sdkVersion,
  sIntegration,
  aIntegration,
  inverseHeaderScheme = false,
  activeNavLocal,
  amplitude = null,
}) => {
  /* TODO: as a new div with id body has been created, correct references in js/css to body element having layout classes to body id,
    we can also change the id in future if needed. */

  const { user, setUser, isScriptLoaded, Cookies } = useApplicationContext() //add elmo data
  const windowSize = useWindowSize()
  let oldHeaderShow = false
  let val =
    typeof window !== `undefined` &&
    window.__INITIALDATA__ &&
    window.__INITIALDATA__.uiramp

  if (!Cookies.get('ppcp_ramp', { path: '/' })) {
    if (val === 'Ctrl_Developer_New_IA') {
      Cookies.set('ppcp_ramp', 'oldia', { path: '/' })
    } else {
      Cookies.set('ppcp_ramp', 'newia', { path: '/' })
    }
  }
  if (Cookies.get('ppcp_ramp', { path: '/' }) === 'classic') {
    oldHeaderShow = true
  } else {
    oldHeaderShow = false
  }

  const getUserInfo = async () => {
    try {
      const { data } = await getRequest('/apis/user')
      setUser(data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getUserInfo()
  }, [])

  useEffect(() => {
    if (isScriptLoaded) {
      window.app.initialize()
      // eslint-disable-next-line no-unused-expressions
      onMount && onMount()
      let origin =
        typeof window !== `undefined` &&
        window.__INITIALDATA__ &&
        window.__INITIALDATA__.isPaypal
      localStorage.setItem('origin', origin)
    }
  }, [isScriptLoaded])

  const renderHeader = () => {
    if (oldHeaderShow === true) {
      return <ParentHeader user={user} location={location} headerType="old" />
    }
    return (
      <ParentHeader
        user={user}
        location={location}
        headerType="new"
        inverseHeaderScheme={inverseHeaderScheme}
      />
    )
  }

  return (
    <div id="body" className={layout}>
      <Helmet htmlAttributes={{ lang: 'en' }}>
        <title>{title}</title>
        <link
          rel="icon"
          sizes="32x32"
          href="https://www.paypalobjects.com/webstatic/developer/favicons/pp32.png"
        />
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {contentType && <meta name="contentType" content={contentType} />}
        {productStatus && <meta name="productStatus" content={productStatus} />}
        {apiVersion && <meta name="apiVersion" content={apiVersion} />}
        {sdkVersion && <meta name="sdkVersion" content={sdkVersion} />}
        {sIntegration && <meta name="sIntegration" content={sIntegration} />}
        {aIntegration && <meta name="aIntegration" content={aIntegration} />}
      </Helmet>
      {renderHeader()}
      <div
        className={`${user.loggedIn && !oldHeaderShow ? 'userloggedIn' : ''}`}
      >
        {isDeprecated ? (
          <IsAPIDeprecated
            apiLatestVersion={apiLatestVersion}
            apiLatestVersionPath={apiLatestVersionPath}
          />
        ) : null}
        <div className={leftNavBar ? 'dx-flex dx-flex-new' : ''}>
          {leftNavBar
            ? windowSize.width > 1023 && (
                <LeftNavigation
                  location={location}
                  leftNav={leftNav}
                  data_type={data_type}
                />
              )
            : null}
          {children}
          {rightNav ? (
            <RightNavigation location={location} rightNav={rightNav} />
          ) : null}
        </div>
        <Footer inverseHeaderScheme={inverseHeaderScheme} />
      </div>
    </div>
  )
}

export default withScriptLoader(Layout)
